import { render } from "./ContractDocuments.vue?vue&type=template&id=39b96cce&scoped=true"
import script from "./ContractDocuments.vue?vue&type=script&lang=js"
export * from "./ContractDocuments.vue?vue&type=script&lang=js"

import "./ContractDocuments.vue?vue&type=style&index=0&id=39b96cce&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b96cce"]])

export default __exports__